import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CategoryCard } from '../components/CategoryCard';
import { Breadcrumb } from '../components/Breadcrumb';
import { findCategoryByPath, buildBreadcrumb } from '../data/categories';
import { ArrowLeft } from 'lucide-react';
export function CategoryPage() {
  const {
    '*': pathParam
  } = useParams();
  const navigate = useNavigate();
  const slugs = pathParam?.split('/').filter(Boolean) || [];
  const category = findCategoryByPath(slugs);
  const breadcrumb = buildBreadcrumb(slugs);
  if (!category) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-257">
        <div className="text-center" data-id="element-258">
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-259">
            Category Not Found
          </h1>
          <button onClick={() => navigate('/explore')} className="text-kithward-700 font-bold hover:underline" data-id="element-260">
            Return to Explore
          </button>
        </div>
      </div>;
  }
  // If no subcategories, redirect to product listing
  if (!category.subcategories || category.subcategories.length === 0) {
    navigate(`/products/${slugs.join('/')}`);
    return null;
  }
  return <div className="min-h-screen bg-gray-50 pb-32 pt-8 px-4 md:px-8" data-id="element-261">
      <div className="max-w-7xl mx-auto" data-id="element-262">
        {/* Back Button */}
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-600 hover:text-kithward-700 mb-6 transition-colors" data-id="element-263">
          <ArrowLeft className="w-5 h-5" data-id="element-264" />
          <span className="font-medium" data-id="element-265">Back</span>
        </button>

        {/* Breadcrumb */}
        <Breadcrumb items={breadcrumb} data-id="element-266" />

        {/* Header */}
        <div className="mb-10" data-id="element-267">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-3" data-id="element-268">
            {category.name}
          </h1>
          {category.description && <p className="text-gray-500 text-lg md:text-xl max-w-3xl" data-id="element-269">
              {category.description}
            </p>}
        </div>

        {/* Subcategories Grid */}
        <div data-id="element-270">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-271">
            Browse by Category
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-272">
            {category.subcategories.map(subcat => <CategoryCard key={subcat.id} name={subcat.name} color={subcat.color} image={subcat.image} onClick={() => {
            const newPath = [...slugs, subcat.slug].join('/');
            // If subcategory has children, go to category page, else go to products
            if (subcat.subcategories && subcat.subcategories.length > 0) {
              navigate(`/category/${newPath}`);
            } else {
              navigate(`/products/${newPath}`);
            }
          }} data-id="element-273" />)}
          </div>
        </div>

        {/* Featured Brands Section (Optional) */}
        <div className="mt-16" data-id="element-274">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-275">
            Featured Brands
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6" data-id="element-276">
            {/* Placeholder brand cards */}
            {[1, 2, 3, 4, 5].map(i => <div key={i} className="bg-white rounded-xl border border-gray-200 p-6 flex items-center justify-center aspect-square hover:shadow-lg transition-shadow cursor-pointer" data-id="element-277">
                <span className="text-gray-400 font-medium text-sm" data-id="element-278">
                  Brand {i}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}